import { z } from 'zod';
/** GET /api/salud response (contracts/http-api.md, "Salud"). No internal details. */
export const saludResponseSchema = z.object({ ok: z.literal(true) });
//# sourceMappingURL=salud.js.map